import React from 'react';
import './style.css';

export default function AffiliateCompanies() {
	return (
		<div className='affiliate-companies'>
			<h2 className='section-title'>Affiliate Companies</h2>
			<p>
				Starlife Group is powered by a network of specialized
				affiliates—Starlife Builders, Starlife Capital Ventures, Starlife
				Development, Starlife International Realty, Starlife Lending, and Amara
				Global Hospitality—each bringing expertise across development,
				construction, capital, real estate services, lending, and hospitality
				management. Together, these companies ensure seamless execution from
				concept to completion on every project.
			</p>
		</div>
	);
}
